import React from 'react'
import './reports.css'
import { Outlet } from 'react-router-dom'
import { DirectiveContextProvider } from './DispatchDirective/DirectiveContext'

export const SupplyDirectives = () => {
  return (
    <DirectiveContextProvider>
      <Outlet />
    </DirectiveContextProvider>
  )
}
